import {
  ListItemButton,
  ListItem,
  ListItemText,
  Typography,
  ListItemAvatar,
  Avatar,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const ItemCantiere = ({ cantiere }: { cantiere: any }) => {
  const navigate = useNavigate();

  function stringAvatar(numpresenze: string) {
    return {
      children: numpresenze,
    };
  }

  return (
    <ListItem
      onClick={() => navigate("/cantiere/" + cantiere.idcantiere, { state: { cantiere: cantiere} })}
      alignItems="flex-start"
      style={{ cursor: "pointer" }}
    >
      <ListItemButton>
        <img src={cantiere.logo_cantiere} style={{width:100, background: '#fff', borderRadius: 5, padding: 5, marginRight: 10}} />
        <ListItemText
          primary={cantiere.nomecantiere}
        />
        <ListItemAvatar>
          <Avatar {...stringAvatar(cantiere.numpresenze)} />
        </ListItemAvatar>
      </ListItemButton>
    </ListItem>
  );
};

export default ItemCantiere;
